import { DataFileModel } from "../api/vehicleFileAPI";

const viewableFileExtensions = [
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".svg",
  ".xml",
];

export function isViewable(filename: string): boolean {
  let extension = filename.substring(filename.lastIndexOf("."));

  if (!extension || extension === "") return false;

  if (viewableFileExtensions.indexOf(extension.toLocaleLowerCase()) !== -1)
    return true;

  return false;
}

export interface DataFileEntry {
  name: string;
  fullPath: string;
  file: DataFileModel | undefined;
  entries: DataFileEntry[];
}

export function compareDataFileEntry(
  a: DataFileEntry,
  b: DataFileEntry,
): number {
  const lastPathIndexA = a.fullPath.lastIndexOf("/");
  const lastPathIndexB = b.fullPath.lastIndexOf("/");

  const parentA =
    lastPathIndexA >= 0 ? a.fullPath.substring(0, lastPathIndexA) : "";
  const parentB =
    lastPathIndexB >= 0 ? b.fullPath.substring(0, lastPathIndexB) : "";

  const parentComparison = parentA.localeCompare(parentB, undefined, {
    sensitivity: "accent",
  });

  if (parentComparison !== 0) {
    return parentComparison;
  }

  // if one of them is a directory it must come first
  if (a.entries.length > 0 && b.entries.length === 0) return -1;
  else if (a.entries.length === 0 && b.entries.length > 0) return 1;

  const filenameA =
    lastPathIndexA >= 0 ? a.fullPath.substring(lastPathIndexA + 1) : a.fullPath;
  const filenameB =
    lastPathIndexB >= 0 ? b.fullPath.substring(lastPathIndexB + 1) : b.fullPath;

  return filenameA.localeCompare(filenameB, undefined, {
    sensitivity: "accent",
  });
}

// used to sort data file entries. added because there could be compatibility issues with toSorted
export function sortDataFileEntries(entries: DataFileEntry[]): DataFileEntry[] {
  let copy = [...entries];
  copy.sort(compareDataFileEntry);
  return copy;
}
